<template>
  <div >
    <div class="aui-book-head" v-if="title">
      <h2>{{title}}</h2>
      <!-- <span  v-if="showMore"  @click="showMoreAction" class="more">更多</span> -->
    </div>
    <div class="aui-list-theme" v-if="type =='history' && books">
      <router-link
        :to="{name: 'novel-home', params: {id: book.bookInfo.bookId}}"
        v-for="book in books"
        :key="book.bookInfo.bookId"
        class="aui-list-theme-item shelf-item"
      >
        <div class="aui-list-img">
          <img imgtype="novel"  :bookid="book.bookInfo.bookId" :booktitle="book.bookInfo.title" :chapternum="0" :imgpath="book.bookInfo.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
          <h3>{{book.bookInfo.title}}</h3>
          <p>{{book.title}}</p>
        </div>
      </router-link>
    </div>
    <div class="aui-list-theme" v-if="type =='shelf'">
      <a
        @click="toBookDetail(book.bookId)"
        v-for="book in books"
        :key="book.bookId"
        class="aui-list-theme-item shelf-item"
      >
        <div class="aui-list-img">
          <img imgtype="novel"  :bookid="book.bookId" :booktitle="book.title" :chapternum="0" :imgpath="book.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
          <h3>{{book.title}}</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span>{{book.categoryName}}</span>
              <span  @click.stop="removeBook(book)" class="remove a">移除</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'books-shelf',
  props: {
    title: String,
    type: {
      type: String,
      default: 'history'
    },
    chapterTitle: String,
    books: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    toBookDetail (id) {
      this.$router.isBack = true
      this.$router.push(`/novels/${id}`)
    },
    removeBook (book) {
      this.$emit('remove-book', book)
    },
    showMoreAction () {
      this.$emit('show-more')
    },
    getPublishStatusText (code) {
      if (code === 'finish') {
        return '完结'
      } else {
        return '连载'
      }
    }
  },
  watch: {
    books (data) {}
  }
}
</script>

<style scoped>

@import "../../assets/css/novel.css";

.aui-list-title h3{ color: #fff; text-align: center;}
.aui-flex-box{ line-height: 1.3rem; height: 1.3rem !important;}
.aui-flex-box span:nth-child(1){line-height: 1.1rem; float: left; padding: 0 .2rem; margin-top: .1rem; background: #333; color: #fff; margin-left: .2rem;  }

</style>




// WEBPACK FOOTER //
// src/components/novel/books-shelf.vue